import { render, staticRenderFns } from "./listH5Component.vue?vue&type=template&id=64b52b32&scoped=true&"
import script from "./listH5Component.vue?vue&type=script&lang=js&"
export * from "./listH5Component.vue?vue&type=script&lang=js&"
import style0 from "./listH5Component.vue?vue&type=style&index=0&id=64b52b32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b52b32",
  null
  
)

export default component.exports